import moment from "moment";
import FileUploadInputComponent from "../../../components/file/file-upload-input.component";
import DynamicDateComponent from "../../../components/report/dynamic-date.component";
import SingleSelectComponent from "../../../components/single-select/single-select.component";
import { DATE_TYPE_CODES, FILE_EXTENSIONS, formats } from "../../../config/constants";
import navigationModel from "../../../models/navigation/navigation.model";
import UploadUserManualModel from "../../../models/upload-uesr-manual/upload-user-manual.model";
import ViewBase from "../../view-base.view";

export default function UploadUserManual() {
  ViewBase.call(this);

  const ID_UPLOAD_FORM = 'UploadManualForm';
  const ID_SEARCH_FORM = 'SearchUserManualForm';

  const DEFAULT_BASE_FILTERS = {
    fromDate: moment().subtract(6, 'months').format(formats.dateFormat),
    toDate: moment().format(formats.dateFormat),
    parameters: []
  };
  let baseFilters = structuredClone(DEFAULT_BASE_FILTERS);

  let menuList = [];
  let uploadedManuals = [];

  let selectedMenu = {};
  let fileToUpload = null;
  let currentResultMenu = ''

  const getDataTypes = (menu) => {
    let level1 = {}
    let level2 = {}
    let res = [];
    menu.forEach(item => {
      if (!item.parentMenuID) {
        level1[item.menuID] = item.name
      }
    })
    menu.forEach(item => {
      if (level1[item.parentMenuID]) {
        level2[item.menuID] = `${level1[item.parentMenuID]} > ${item.name}`
      }
    })
    menu.forEach(item => {
      if (item.path) {
        let name = item.name;
        if (level2[item.parentMenuID]) {
          name = level2[item.parentMenuID] + ' > ' + name
        } else if (level1[item.parentMenuID]) {
          name = level1[item.parentMenuID] + ' > ' + name
        }
        res.push({ code: item.menuID, name })
      }

    })
    menuList = res.sort((a, b) => {
      if (a.name > b.name) return 1
      if (a.name < b.name) return -1
      return 0
    });
  }

  const onUpload = (e) => {
    e.preventDefault();
    if (!this.validateForm(e, '#' + ID_UPLOAD_FORM)) {
      return false;
    }
    const formData = new FormData();
    formData.set('uploadedExcel', fileToUpload);

    this.showLoading();
    return UploadUserManualModel.uploadUserManual(selectedMenu.code, formData)
      .then((result) => {
        if (result !== null && result.length > 0) {
          this.showMessage(this.getText(result[0].Code, result[0].Message) ?? this.getText('LT00000914', 'The file has been uploaded successfully'), result[0].transStatus, getUserManual);
        } else {
          this.showErrorMessage(this.getText('EM00000082', 'Invalid file. Cannot process.'), this.getText('EM00000058', 'Invalid file.'));
        }
      })
      .catch(error => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading(); });
  }
  const requestParams = {
    get menuId() {
      return selectedMenu.code
    },

    get fromDate() {
      return moment(baseFilters.fromDate).format(formats.apiDateFormat)
    },

    get toDate() {
      return moment(baseFilters.toDate).add(1, 'd').format(formats.apiDateFormat)
    },
  }

  const getUserManual = () => {
    this.showLoading();
    return UploadUserManualModel.getUserManual(requestParams)
      .then((result) => {
        currentResultMenu = selectedMenu.name;
        uploadedManuals = result ?? [];
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const onSearch = (e) => {
    e.preventDefault();
    if (!this.validateForm(e, '#' + ID_SEARCH_FORM)) {
      return false;
    }
    getUserManual();
  }

  const downloadRawDataUploadResultType = (fileId, fileName) => {
    return UploadUserManualModel.downloadUserManual(fileId, fileName)
      .catch(error => {
        this.handleError(error);
      });
  }

  return {
    oninit: () => {
      getDataTypes(navigationModel.activeMenuList);
    },
    view: () => [
      m('.vstack.gap-2',
        m('form.card.needs-validation[novalidate]', {
          id: ID_UPLOAD_FORM,
          onsubmit: onUpload
        },
          m('.card-body.row.gap-1',
            m('.col-xl-5.position-relative',
              m('label.form-label.mandatory', this.getText('LT00000785', 'Menu')),
              m(SingleSelectComponent, {
                required: true,
                allowEmpty: false,
                selectedItem: selectedMenu,
                items: menuList,
                onSelect: (selectedItem) => {
                  selectedMenu = selectedItem;
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            ),
            m('.w-100'),
            m('.col-xl-5.position-relative',
              m('label.form-label.mandatory', this.getText('LT00000792', 'File Upload')),
              m(FileUploadInputComponent, {
                required: true,
                accept: FILE_EXTENSIONS.PDF,
                onInput: (uploadedFile) => {
                  fileToUpload = uploadedFile;
                }
              }),
              m('.invalid-tooltip', this.getText("LT00000729", "This field is required"))
            ),
            m('.col-12.hstack.justify-content-end',
              m('button.btn.btn-primary[type="submit"]', this.getText('LT00000290', 'Upload'))
            )
          )
        ),
        m('form.card.needs-validation[novalidate]', {
          id: ID_SEARCH_FORM,
          onsubmit: onSearch
        },
          m('.card-body.vstack.gap-2',
            m('.row.g-2',
              m('.col-xl-3',
                m(DynamicDateComponent, {
                  selectedDateType: DATE_TYPE_CODES.DATE,
                  supportedDates: [DATE_TYPE_CODES.DATE],
                  required: true,
                  fromDate: baseFilters.fromDate,
                  toDate: baseFilters.toDate,
                  onChange: (_, fromDate, toDate) => {
                    baseFilters.fromDate = fromDate;
                    baseFilters.toDate = toDate;
                  }
                })
              ),
            ),
            m('.hstack.justify-content-end',
              m('button.btn.btn-primary[type="submit"]', this.getText('LT00000001', 'Search'))
            )
          )
        ),
        m('.card',
          m('.card-body',
            m('.table-responsive',
              m('table.table',
                m('thead',
                  m('tr',
                    m('th', this.getText('LT00000785', 'Menu')),
                    m('th', this.getText('LT00008098', 'File Id')),
                    m('th', this.getText('LT00008068', 'Upload Date')),
                    m('th', this.getText('LT00008073', 'Upload By')),
                  )
                ),
                m('tbody',
                  uploadedManuals.length > 0
                    ? uploadedManuals.map((file, index) =>
                      m('tr',
                        m('td', index === 0 && currentResultMenu),
                        m('td',
                          m('a.link-primary', {
                            href: '#',
                            onclick: (e) => {
                              e.preventDefault();
                              downloadRawDataUploadResultType(file.fileId, file.originalFileName)
                            }
                          }, file.originalFileName)

                        ),
                        m('td', file.createDate),
                        m('td', file.createUser),
                      ))
                    : m('td', { colspan: '100%' }, this.getText("EM00000141", "No records found."))
                )
              )
            )
          )
        )
      ),
      this.getBaseViews()
    ]
  }
}